var SubscriptionLog = /*@__PURE__*/ (function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) {
            unsubscribedFrame = Number.POSITIVE_INFINITY;
        }
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}());
export { SubscriptionLog };
//# sourceMappingURL=SubscriptionLog.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/testing/SubscriptionLog.js
// module id = 676
// module chunks = 0